import { getField, updateField } from 'vuex-map-fields';


const state = () => ({
    show_contract: false,
    show_policy_privacity: false,
    show_data_treatment: false,
});


const mutations = {
    SHOW_CONTRACT: (state) => {
        state.show_contract = true;
    },
    HIDE_CONTRACT: (state) => {
        state.show_contract = false;
    },
    SHOW_POLICY_PRIVACITY: (state, show) => {
        state.show_policy_privacity = show;
    },
    HIDE_POLICY_PRIVACITY: (state, show) => {
        state.show_policy_privacity = false ;
    },
    SHOW_DATA_TREATMENT: (state, show) => {
        state.show_data_treatment = show;
    },
    HIDE_DATA_TREATMENT: (state, show) => {
        state.show_data_treatment = false ;
    },
    updateField,
};


const getters = {
    show_contract: state => state.show_contract,
    show_policy_privacity: state => state.show_policy_privacity,
    show_data_treatment: state => state.show_data_treatment,
    getField
}


const showContract = ({ commit }) => {
    commit('SHOW_CONTRACT', true);
}

const hideContract = ({commit}) => {
    commit('HIDE_CONTRACT', false);
}

const showPolicyPrivacity = ({ commit }) => {
    commit('SHOW_POLICY_PRIVACITY', true);
}

const hidePolicyPrivacity = ({commit}) => {
    commit('SHOW_POLICY_PRIVACITY', false);
}

const showDataTreatment = ({ commit }) => {
    commit('SHOW_DATA_TREATMENT', true);
}

const hideDataTreatment = ({commit}) => {
    commit('SHOW_DATA_TREATMENT', false);
}

const printContract = ({commit}) => {
    let dialog = document.getElementsByClassName('v-dialog--active')
    if (dialog[0]) {
        dialog[0].style.position = 'static';
        dialog[0].style.boxShadow = 'none';
    }
    let application  = document.getElementsByClassName('v-application--wrap');
    if (application[0]) {
        application[0].style.display = 'none';
    }
    window.print()
    if (dialog[0]) {
        dialog[0].style.position = 'fixed';
    }
    if (application[0]) {
        application[0].style.display = 'flex';
    }
}

const actions = {
    showContract,
    hideContract,
    showPolicyPrivacity,
    hidePolicyPrivacity,
    showDataTreatment,
    hideDataTreatment,
    printContract
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}